import axios from 'axios';
import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';

//doc: https://secure-backend-api-internal-staging.stilingue.com.br/social-metrics-endpoint/staging/swagger-ui/index.html?configUrl=/social-metrics-endpoint/staging/v3/api-docs/swagger-config#/listening-endpoint-controller/forceUpdate

export interface SocialMetrics {
  status: string;
  message: string;
}

class SocialMetricsService {
  private createAuthenticatedAxios() {
    const axiosInstance = axios.create();
    
    axiosInstance.interceptors.request.use((config) => {
      const token = Cookies.get(CONFIG.AUTH.SSID);

      if (token) {
        config.headers = config.headers ?? {};
        (config.headers as Record<string, string>)[CONFIG.AUTH.SSID] = token;
      }

      return config;
    });

    return axiosInstance;
  }

  async forceUpdate(
    channel: string,
    pid: string,
    uid: string
  ): Promise<SocialMetrics> {

    const gateway = CONFIG.getSecureStagingGatewayUrl();
    const version = CONFIG.getVersion();

    const url = `${gateway}social-metrics-endpoint/${version}/socialmetrics/force_update`;
    const payload = {
      channel: channel,
      pid: pid,
      uid: uid,
    };
    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.post(url, payload);

    return response.data;
  }
}

const socialMetricsService = new SocialMetricsService();
export default socialMetricsService;